import React from 'react';
import createReactClass from 'create-react-class';
import { Link } from 'react-router-dom';

import request from '../../helpers/request';
import SimplePage from '../common/SimplePage';
import NeedsClaim from '../common/NeedsClaim';
import Modal from '../common/Modal';
import itemConfig from './config/itemConfig';
import setViewTitle from '../../helpers/setViewTitle';
import IncompleteDataMessages from '../common/IncompleteDataMessages';
import moment from 'moment';

const $ = window.$;

var ItemCard = createReactClass({
  actions: [],

  getInitialState() {
    return {
      hasBeenFound: false,
      item: {
        vendors: []
      },
      history: []
    };
  },

  componentWillMount() {
    setViewTitle('Artikelkarte');
  },

  componentDidMount() {
    this.actions = [
        {title: 'Neuer Artikel', to: '/items/new', claim: 'items:write'},
        {title: 'Artikel bearbeiten', to: `/items/edit/${this.props.match.params.itemId}`, claim: 'items:write'},
        {title: 'Artikel löschen', to: '#', onClick: () => this.removeItemModal.show(), claim: 'items:write'},
        {title: 'Lieferanten', to: `/items/${this.props.match.params.itemId}/vendors`, claim: 'items:write'}
    ];

    request.get({
      url: itemConfig.apiUrl + this.props.match.params.itemId,
      success: data => {
        if (this.isMounted()) {
          this.setState({
            hasBeenFound: true,
            item: data
          });

          request.get({
            url: itemConfig.apiUrl + this.props.match.params.itemId + '/history',
            success: data => {
              if (this.isMounted()) {
                this.setState({
                  history: data
                }, () => this.setupHistoryChart());
              }
            }
          });
        }
      }
    });
  },

  handleConfirmRemoveItem() {
    request.del({
      url: itemConfig.apiUrl + this.props.match.params.itemId,
      success: () => {
        this.props.history.push(`/items`);
      }
    });
  },

  setupHistoryChart() {
    if(this.state.history.length === 0) {
      return;
    }

    var $chrt_border_color = '#efefef';
    var $chrt_second = '#6595b4';

    var d = this.state.history.map(x => [moment(x.dateCreated).format('x'), x.quantity]);

    var options = {
      xaxis : {
        mode : 'time',
        tickLength : 5
      },
      series : {
        lines : {
          show : true,
          lineWidth : 1,
          fill : true,
          fillColor : {
            colors : [{
              opacity : 0.1
            }, {
              opacity : 0.15
            }]
          }
        },
        //points: { show: true },
        shadowSize : 0
      },
      selection : {
        mode : 'x'
      },
      grid : {
        hoverable : true,
        clickable : true,
        tickColor : $chrt_border_color,
        borderWidth : 0,
        borderColor : $chrt_border_color,
      },
      tooltip : true,
      tooltipOpts : {
        content : '%y',
        dateFormat : '%y-%0m-%0d',
        defaultTheme : false
      },
      colors : [$chrt_second],
    };

    $.plot($('#stock-chart'), [d], options);
  },

  render() {

    let incompleteDataMessages = [];

    if(this.state.hasBeenFound) {
      if(this.state.item.vendors.length === 0) {
        incompleteDataMessages.push('Artikel hat keinen Lieferanten definiert');
      } else {
        this.state.item.vendors.forEach(x => {
          if(x.purchaseUnits.length === 0) {
            incompleteDataMessages.push(`Artikellieferant '${x.vendorName}' hat keine Einheiten definiert`);
          }
        });
      }
    } else {
      return null;
    }

    return (
      <div>
        <SimplePage title={this.state.item.name} icon="cubes" actions={this.actions}>
          <div className="table-responsive">
            <table className="table table-bordered table-striped">
                <tbody>
                    <tr><td width="35%">Name</td><td width="65%">{this.state.item.name}</td></tr>
                    <tr><td width="35%">Lagerort</td><td width="65%">{this.state.item.defaultStorageLocationName}</td></tr>
                    <tr><td width="35%">Lagerplatz</td><td width="65%">{this.state.item.defaultStorageBinName}</td></tr>
                    <tr><td width="35%">Im Lager</td><td width="65%">{this.state.item.totalStockQuantity}</td></tr>
                    <tr><td width="35%">Durchschnittspreis</td><td width="65%">{this.state.item.avgNetPrice.toFixed(2) + '€'}</td></tr>
                    <tr><td width="35%">Bestellt</td><td width="65%">{this.state.item.orderedQuantity}</td></tr>
                    <tr><td width="35%">Mindestmenge</td><td width="65%">{this.state.item.lowStockLimit}</td></tr>
                    <tr><td width="35%">Basiseinheit</td><td width="65%">{this.state.item.stockUnit}</td></tr>
                    <NeedsClaim claim="items:write">
                      <tr>
                        <td width="35%"><Link to={`/items/${this.state.item.id}/vendors`}>Lieferanten</Link></td>
                        <td width="65%"><Link to={`/items/${this.state.item.id}/vendors`}>{this.state.item.vendors.length}</Link></td>
                      </tr>
                    </NeedsClaim>
                </tbody>
            </table>
          </div>
          <NeedsClaim claim="items:write">
            <IncompleteDataMessages messages={incompleteDataMessages} />
          </NeedsClaim>

          <form className="smart-form">
              <footer>
                  <Link to="/items" className="btn btn-default">Zurück</Link>
              </footer>
          </form>
        </SimplePage>

        {this._getHistory()}

        <Modal
          ref={c => this.removeItemModal = c}
          title="Artikel löschen?"
          message={`Soll der Artikel '${this.state.item.name}' wirklich gelöscht werden?`}
          confirmButtonText="Ja, löschen"
          onConfirm={() => this.handleConfirmRemoveItem()}
        />
      </div>
    );
  },

  _getHistory() {
    if(this.state.history.length === 0) {
      return;
    }

    let historyEntries = this.state.history.map(x => {
      var createdString = moment(x.dateCreated).format('DD.MM.YYYY HH:mm');

      return (<li>
          <div className="smart-timeline-icon">
              <i className="fa fa-file-text"></i>
          </div>
          <div className="smart-timeline-time">
              <small>{createdString}</small>
          </div>
          <div className="smart-timeline-content">
              <p>
                <a><strong>{x.title}</strong></a>
              </p>
              <p>
                {x.description}
              </p>
          </div>
      </li>);
    });

    return (
      <div className="row">
          <article className="col-sm-10">
              <div className="jarviswidget" id="wid-id-0" data-widget-togglebutton="false" data-widget-editbutton="false" data-widget-fullscreenbutton="false" data-widget-colorbutton="false" data-widget-deletebutton="false">
                  <header>
                      <span className="widget-icon"> <i className="glyphicon glyphicon-stats txt-color-darken"></i> </span>
                      <h2>Artikelübersicht </h2>

                      <ul className="nav nav-tabs pull-right in" id="myTab">
                          <li className="active">
                              <a data-toggle="tab" href="#s1"><i className="fa fa-clock-o"></i> <span className="hidden-mobile hidden-tablet">Historie</span></a>
                          </li>

                          <li>
                              <a data-toggle="tab" href="#s3" onClick={this.onChartTabShow}><i className="fa fa-bar-chart-o"></i> <span className="hidden-mobile hidden-tablet">Grafik</span></a>
                          </li>
                      </ul>

                  </header>

                  <div className="no-padding">
                      <div className="jarviswidget-editbox"></div>

                      <div className="widget-body">
                          <div id="myTabContent" className="tab-content">
                              <div className="tab-pane fade active in padding-10 no-padding-bottom" id="s1">
                                  <div className="row no-space">
                                      <div className="col-md-12">
                                          <div>
                                              <div className="well well-sm">
                                                  <div className="smart-timeline">
                                                      <ul className="smart-timeline-list">

                                                        {historyEntries}

                                                      </ul>
                                                  </div>
                                              </div>
                                          </div>

                                      </div>
                                  </div>
                              </div>

                              <div className="tab-pane fade in padding-10 no-padding-bottom" id="s3">

                                  <div className="row no-space">
                                      <div id="stock-chart" className="chart-large txt-color-blue"></div>
                                  </div>
                              </div>
                          </div>

                      </div>

                  </div>
              </div>

          </article>
      </div>);
  }

});

export default ItemCard;



// WEBPACK FOOTER //
// ./src/components/items/ItemCard.js